module.exports = __webpack_public_path__ + "card1-v1.3811862ef674dad8f44dc8633e7732ef.jpg";